import columns from '../../../../react-table/helpers/columns';

export const toggleRowButtonProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo &&
    (!rowInfo.row.receptacleIds || rowInfo.row.receptacleIds.length < 2) &&
    (!rowInfo.row.postalScanDate || rowInfo.row.postalScanDate.length < 2)) {
    className = 'not-expandable';
  }
  return {
    className,
  };
};

export default (data) => {
  const {
    TextColumn,
    DateTimeColumn,
    ToggleRowButtonColumn,
    NonZeroNumberColumn,
    MultilineDateTimeColumn,
    MultilineExternalReceptacleLinkColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new ToggleRowButtonColumn().withGetProps(toggleRowButtonProps),
        new TextColumn('MRD label', 'mrdLabel'),
        new TextColumn('MRD location', 'mrdLocation'),
        new TextColumn('Device ID', 'deviceId'),
        new TextColumn('Carrier', 'carrier'),
        new TextColumn('Conveyance reference', 'conveyanceReference'),
        new DateTimeColumn('Planned arrival', 'plannedArrivalDate'),
        new TextColumn('Origin', 'origin'),
        new TextColumn('Handler', 'handler'),
        new MultilineExternalReceptacleLinkColumn('Scanned ID / receptacle ID', 'receptacleIds')
          .withWidth(300)
          .withExpandable('non-clickable-first-link'),
        new MultilineExternalReceptacleLinkColumn('Scanned ID / receptacle ID', 'escapedReceptacleIds').withShow(false),
        new MultilineDateTimeColumn('Postal scan date', 'postalScanDate')
          .withWidth(140)
          .withExpandable(),
        new DateTimeColumn('Handover date', 'handoverDate')
          .withWidth(140),
        new DateTimeColumn('Actual arrival', 'actualArrival'),
        new TextColumn('Actual arrival - handover date', 'actualArrivalHandoverDate'),
        new TextColumn('Postal scan - handover date', 'postalScanHandoverDate'),
        new NonZeroNumberColumn('Receptacles', 'receptacles'),
        new TextColumn('POP transport', 'popTransport'),
        new DateTimeColumn('POP - handover date', 'popHandoverDate'),
        new DateTimeColumn('POP - handover time', 'popHandoverTime'),
      ],
    },
  ];
};
